import { type QuestionConfig } from "@/screens/prequal/questions"
import { Horizontal } from "@/components/standard/BFLayout"
import { H5 } from "@/components/standard/BFText"
import { AccordionTrigger } from "@/components/reusables/ui/accordion"

export const PreQualTrigger = ({
  question,
  value,
}: {
  question: QuestionConfig
  value: string
}) => {
  return (
    <AccordionTrigger>
      <Horizontal className={"justify-between items-center flex-1 py-2"}>
        <H5 color={"primary"}>{question.title}</H5>
        <H5 color={"primaryLight"} className={"mr-2"}>
          {question?.displayValue ? question.displayValue(value) : value}
        </H5>
      </Horizontal>
    </AccordionTrigger>
  )
}
